export default {
  namespaced: true,
  state: {
    activePayment: "stripe_cards",
    stripe: {},
    stripeCardStyle: {
      base: {
        color: "#32325d",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  },
  getters: {
    globalStripe: state => state.stripe,
    stripeCardStyle: state => state.stripeCardStyle,
    getActivePayment: state => state.activePayment,
  },
  actions: {
    setGlobalStripe: (context, stripe) => {
      context.commit("setGlobalStripe", stripe);
    },
    setActivePayment: (context, paymentId) => {
      context.commit("setActivePayment", paymentId);
    },
  },
  mutations: {
    setGlobalStripe: (state, stripe) => {
      state.stripe = stripe;
    },
    setActivePayment: (state, paymentId) => {
      state.activePayment = paymentId;
    },
  },
};
